import { c as _c } from "react/compiler-runtime";
import { getOrgRolesOptions } from '@onefootprint/fetch-dashboard';
import { useIntl } from '@onefootprint/hooks';
import { getErrorMessage } from '@onefootprint/request';
import type { OffsetPaginatedOrganizationRole, OrganizationRole, TenantRoleKindDiscriminant } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import usePagination from '@/hooks/use-pagination';
import useRolesQueryParams from './use-roles-query-params';
const useRoles = kind => {
  const $ = _c(25);
  const {
    formatDateWithTime
  } = useIntl();
  const queryParams = useRolesQueryParams();
  const {
    requestParams
  } = queryParams;
  let t0;
  if ($[0] !== kind || $[1] !== requestParams.page || $[2] !== requestParams.pageSize || $[3] !== requestParams.search) {
    t0 = getOrgRolesOptions({
      query: {
        kind,
        page: requestParams.page,
        pageSize: requestParams.pageSize,
        search: requestParams.search
      }
    });
    $[0] = kind;
    $[1] = requestParams.page;
    $[2] = requestParams.pageSize;
    $[3] = requestParams.search;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== formatDateWithTime) {
    t1 = response => ({
      meta: response.meta,
      data: response.data.map(role => ({
        ...role,
        createdAt: formatDateWithTime(new Date(role.createdAt))
      }))
    });
    $[5] = formatDateWithTime;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== queryParams.isReady || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      ...t0,
      enabled: queryParams.isReady,
      select: t1
    };
    $[7] = queryParams.isReady;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const rolesQuery = useQuery(t2);
  const t3 = rolesQuery.data?.meta.count;
  const t4 = rolesQuery.data?.meta.nextPage;
  let t5;
  if ($[11] !== queryParams) {
    t5 = newPage => queryParams.push({
      rolesPage: newPage
    });
    $[11] = queryParams;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== queryParams.values.page || $[14] !== queryParams.values.pageSize || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = {
      count: t3,
      next: t4,
      onChange: t5,
      page: queryParams.values.page,
      pageSize: queryParams.values.pageSize
    };
    $[13] = queryParams.values.page;
    $[14] = queryParams.values.pageSize;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const pagination = usePagination(t6);
  let t7;
  if ($[19] !== rolesQuery.error) {
    t7 = rolesQuery.error ? getErrorMessage(rolesQuery.error) : undefined;
    $[19] = rolesQuery.error;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const errorMessage = t7;
  let t8;
  if ($[21] !== errorMessage || $[22] !== pagination || $[23] !== rolesQuery) {
    t8 = {
      ...rolesQuery,
      errorMessage,
      pagination
    };
    $[21] = errorMessage;
    $[22] = pagination;
    $[23] = rolesQuery;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
export default useRoles;